export enum FIELD_NAMES {
  EMAIL = "email",
}

export const MAX_FORM_FIELDS_LENGTH = 24;
